import { useEffect } from "react";
import { DE_CONTENT, EN_CONTENT, NL_CONTENT } from "./translations";
import * as CookieConsent from "vanilla-cookieconsent";
import { useDispatch } from "react-redux";
import { addLittledataAttributes } from "actions/cart";

const getConsentStatus = (data, type) =>
	data?.categories?.includes(type) ? "granted" : "denied";

const updateGTMConsent = (storedConsent) => {
	window.gtag("consent", "update", {
		ad_storage: getConsentStatus(storedConsent, "ad_storage"),
		analytics_storage: getConsentStatus(storedConsent, "analytics_storage"),
		ad_user_data: getConsentStatus(storedConsent, "ad_storage"),
		ad_personalization: getConsentStatus(storedConsent, "ad_storage"),
	});
	window.dataLayer.push({ event: "update_consent" });
};

const CookieConsentModal = ({ current_lang }) => {
	const dispatch = useDispatch();

	useEffect(() => {
		const storedConsent = CookieConsent.getCookie();

		if (storedConsent?.categories?.length) {
			updateGTMConsent(storedConsent);
		}

		CookieConsent.run({
			hideFromBots: true,
			revision: 1,
			disablePageInteraction: true,
			onFirstConsent: ({ cookie }) => {
				updateGTMConsent(cookie);
				dispatch(addLittledataAttributes());
			},

			categories: {
				necessary: {
					readOnly: true,
					enabled: true,
				},
				analytics_storage: {
					enabled: false,
				},
				ad_storage: {
					enabled: false,
				},
			},

			guiOptions: {
				consentModal: {
					layout: "box",
					position: "middle center",
					transition: "slide",
					flipButtons: false,
				},
				preferencesModal: {
					layout: "box",
					transition: "slide",
				},
			},

			language: {
				default: current_lang,
				translations: { en: EN_CONTENT, de: DE_CONTENT, ch: DE_CONTENT, nl: NL_CONTENT }
			},
		});
	}, []);

	return null;
};

export default CookieConsentModal;
